var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ans),expression:"ans"}],domProps:{"value":(_vm.ans)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ans=$event.target.value}}})}
var staticRenderFns = []

export { render, staticRenderFns }